import React from "react";

interface IconTagProps {
  color: string;
}

const IconTag: React.FC<IconTagProps> = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.11133 9.79688C2.11133 7.58774 3.90219 5.79688 6.11133 5.79688H14.556C15.617 5.79688 16.6345 6.21837 17.3846 6.96862L21.3851 10.9696C22.947 12.5317 22.947 14.064 21.3851 15.6261L17.3846 18.6271C16.6345 19.3773 15.617 19.7988 14.556 19.7988H6.11133C3.90219 19.7988 2.11133 18.008 2.11133 15.7988V9.79688ZM14.6738 12.7969C14.6738 11.9689 15.3458 11.2969 16.1738 11.2969C17.0018 11.2969 17.6738 11.9689 17.6738 12.7969C17.6738 13.6249 17.0018 14.2969 16.1738 14.2969C15.3458 14.2969 14.6738 13.6249 14.6738 12.7969Z"
        fill={color}
      />
    </svg>
  );
};

export default IconTag;
